import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { LogOut, KeyRound } from "lucide-react";
import NotificationsBell from "@/components/NotificationsBell";
import { BrandMark } from "@/components/Brand";

export default function Navbar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  return (
    <header className="sticky top-0 z-50 bg-background/80 backdrop-blur-xl border-b border-border/60">
      <div className="max-w-7xl mx-auto px-6 py-3 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="nav-logo">
          <BrandMark size={36} />
        </Link>
        <nav className="flex items-center gap-2">
          {user ? (
            <>
              <NotificationsBell />
              <span className="hidden sm:inline text-sm text-muted-foreground">Hi, {user.name?.split(" ")[0]}</span>
              <Link to="/change-password" className="btn-ghost text-sm hidden sm:inline-flex items-center gap-1" data-testid="nav-change-pw" title="Change password">
                <KeyRound size={14}/>
              </Link>
              <Button variant="outline" className="rounded-full" onClick={() => { logout(); nav("/"); }} data-testid="nav-logout">
                <LogOut size={16} className="mr-1" /> Logout
              </Button>
            </>
          ) : (
            <>
              <Link to="/personas" className="btn-ghost text-sm" data-testid="nav-personas">Try demo</Link>
              <Link to="/login" className="btn-ghost text-sm" data-testid="nav-login">Login</Link>
              <Link to="/register" className="btn-primary text-sm" data-testid="nav-signup">Get started</Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
